import React from 'react';
import { F2120 } from '../../../services/pw2202Api';

interface Tab1Props {
  formData: Partial<F2120>;
  names: Record<string, string>;
  isEditing: boolean;
  getField: (key: keyof F2120) => F2120[keyof F2120];
  setField: (key: keyof F2120, value: F2120[keyof F2120]) => void;
  resolveSingleName: (nameKey: string, type: string, code: string) => void;
}

/** Tab 1: 採購退回（廠商資訊） */
const Tab1BasicInfo: React.FC<Tab1Props> = React.memo(({
  formData, names, isEditing, getField, setField, resolveSingleName,
}) => {
  return (
    <div className="tab-content-section">
      <div className="form-grid">
        {/* 庫號 + 倉庫名稱 (F2120_07 lookup → F105) */}
        <label>庫號</label>
        <div className="lookup-field">
          <input
            type="text"
            value={String(getField('f2120_07') || '')}
            onChange={e => setField('f2120_07', e.target.value)}
            onBlur={() => resolveSingleName('warehouse', 'warehouse', String(getField('f2120_07') || ''))}
            disabled={!isEditing}
            maxLength={4}
            style={{ width: 80 }} data-contract-field="f2120_07"
          />
          <span className="lookup-name">{names.warehouse || ''}</span>
        </div>

        {/* 人員代號 + 員工姓名 (F2120_12 lookup → F901) */}
        <label>人員代號</label>
        <div className="lookup-field">
          <input
            type="text"
            value={String(getField('f2120_12') || '')}
            onChange={e => setField('f2120_12', e.target.value)}
            onBlur={() => resolveSingleName('employee', 'employee', String(getField('f2120_12') || ''))}
            disabled={!isEditing}
            maxLength={8}
            style={{ width: 100 }} data-contract-field="f2120_12"
          />
          <span className="lookup-name">{names.employee || ''}</span>
        </div>

        {/* 公司代號(廠商) + 廠商名稱 (F2120_13 lookup → F104) */}
        <label>公司代號</label>
        <div className="lookup-field">
          <input
            type="text"
            value={String(getField('f2120_13') || '')}
            onChange={e => setField('f2120_13', e.target.value)}
            onBlur={() => resolveSingleName('vendor', 'vendor', String(getField('f2120_13') || ''))}
            disabled={!isEditing}
            maxLength={12}
            style={{ width: 120 }} data-contract-field="f2120_13"
          />
          <span className="lookup-name">{names.vendor || ''}</span>
        </div>

        {/* 單據說明 (F2120_15) */}
        <label>單據說明</label>
        <div style={{ gridColumn: 'span 3' }}>
          <input
            type="text"
            value={String(getField('f2120_15') || '')}
            onChange={e => setField('f2120_15', e.target.value)}
            disabled={!isEditing}
            maxLength={80}
            style={{ width: '100%' }} data-contract-field="f2120_15"
          />
        </div>
      </div>
    </div>
  );
});

Tab1BasicInfo.displayName = 'Tab1BasicInfo';
export default Tab1BasicInfo;
